module.exports = __webpack_public_path__ + "img/07.191e7cfc.jpg";